export class AdminGroupSelectItem {
  groupId: number;
  groupName: string = "";

  constructor(groupId: number, init?: Partial<AdminGroupSelectItem>) {
    if (init) Object.assign(this, init);
    this.groupId = groupId;
  }
}